<template>
  <div>
    <Navbar />
    <div class="columns">
      <SideBar class="menu-sidebar"/>
      <section class="qi-content">
        <header>
          <h1>Importar Mailing com Excel Padrão</h1>
        </header>
        <vs-row>
          <NewSale />
        </vs-row>
        <div v-if="valide.table">
          <vs-table
            class="pd-table"
            :max-items="pageItems[0]"
            pagination
            :data="contentFile"
            description
            :description-items="pageItems"
            noDataText="Sem resultados para serem exibidos"
            description-title="Elementos"
            description-connector="Total"
            description-body=""
          >
            <template slot="thead">
              <th> Status </th>
              <th> Campos </th>
              <th> Resumo </th>
              <th> Progresso </th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :key="i" v-for="(tr, i) in data">
                <vs-td class="centerx">
                  <vs-icon
                    icon="check"
                    color="warning"
                    v-if="
                      data[i].status.hasSend === true &&
                      data[i].status.send === false
                    "
                  ></vs-icon>
                  <vs-icon
                    icon="close"
                    color="danger"
                    v-if="
                      data[i].status.hasSend === false &&
                      data[i].status.send === false
                    "
                  ></vs-icon>
                  <vs-icon
                    icon="cancel"
                    color="danger"
                    v-if="
                      data[i].finish === true &&
                      data[i].status.hasSend === true &&
                      data[i].status.send === false
                    "
                  ></vs-icon>
                  <vs-icon
                    icon="done_all"
                    color="success"
                    v-if="
                      data[i].finish === true &&
                      data[i].status.hasSend === true &&
                      data[i].status.send === true
                    "
                  ></vs-icon>
                </vs-td>
                <vs-td>
                  {{ data[i].name }}<br />
                  <div class="small">
                    <span> Telefone: {{ data[i].phone }} </span>
                    <span v-show="data[i].mail">
                      <br />Email: {{ data[i].mail }}
                    </span>
                    <span v-show="data[i].codCourse ">
                      <br />CodCurso: {{ data[i].codCourse }}
                    </span>
                    <span v-show="data[i].course">
                      <br />Curso: {{ data[i].course }}
                    </span>
                    <span v-show="data[i].note">
                      <br />Obs: {{ data[i].note }}
                    </span>
                  </div>
                </vs-td>
                <vs-td>{{ data[i].status.excerpt }}</vs-td>
                <vs-td>
                  <vs-progress
                    v-if="data[i].progress == 100"
                    :percent="data[i].progress"
                    :height="12"
                    color="success"
                  ></vs-progress>
                  <vs-progress
                    v-else
                    :percent="data[i].progress"
                    :height="12"
                    color="warning"
                  ></vs-progress>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <vs-row v-if="importProgress.start">
            <vs-col v-if="importProgress.percent == 100">
              <vs-progress
                :height="3"
                :percent="importProgress.percent"
                color="primary"
              ></vs-progress>
              <h3 class="centerx">Importação Concluída</h3>
            </vs-col>
            <vs-col v-else>
              <vs-progress
                :height="30"
                :percent="importProgress.percent"
                color="warning"
              ></vs-progress>
              <p class="centerx">
                lendo {{ importProgress.initial }} / total válido
                {{ importProgress.total }}
              </p>
            </vs-col>
          </vs-row>
          <vs-row v-else>
            <vs-col>
              <a v-on:click="sendMailerGroup" class="bt_import w-100"
                >COMEÇAR IMPORTAÇÃO</a
              >
            </vs-col>
          </vs-row>
        </div>
        <div v-else>
          <p class="legend_form">Preencha o Formulário:</p>
          <vs-row>
            <vs-col vs-lg="4" vs-sm="12">
              <vs-select
                class="w100"
                label="Fila de Atendimento"
                v-model="service.selected"
                v-on:change="valideFileForm"
              >
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.text"
                  v-for="(item, index) in service.item"
                />
              </vs-select>
            </vs-col>
            <vs-col vs-lg="4" vs-sm="12">
              <vs-select
                class="w100"
                label="Localidade"
                v-model="locality.selected"
                v-on:change="valideFileForm"
              >
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.text"
                  v-for="(item, index) in locality.item"
                />
              </vs-select>
            </vs-col>
            <vs-col vs-lg="4" vs-sm="12">
              <vs-select
                class="w100"
                label="Campanha"
                v-model="campaing.selected"
                v-on:change="valideFileForm"
              >
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.text"
                  v-for="(item, index) in campaing.item"
                />
              </vs-select>
            </vs-col>
          </vs-row>
          <vs-row v-show="valide.inputFile">
            <vs-col>
              <label id="boxDrop" ref="fileBoxDrop">
                <p v-html="innerHTML.boxInput"></p>
                <input type="file" hidden accept=".xlsx" />
              </label>
            </vs-col>
          </vs-row>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import Mailing from "../services/mailing";
import { validatePhone } from "../helpers/validation";
import XLSX from "xlsx";
export default {
  name: "ImportedMailing",
  data: () => ({
    valide: {
      inputFile: false,
      table: false,
    },
    innerHTML: {
      boxInput:
        "ARRASTE OU CLIQUE PARA ENVIAR SEU ARQUIVO <br/><small>NO FORMATO XLSX</small>",
    },
    notify: {
      success: null,
      error: null,
    },
    sale: {
      blocked: ["211"],
      selected: "213",
      item: [],
    },
    service: {
      selected: null,
      item: [],
    },
    locality: {
      selected: null,
      item: [],
    },
    campaing: {
      selected: null,
      item: [],
    },
    inputFileXLS: null,
    pageItems: [10, 50, 150],
    contentFile: [],
    importProgress: {
      start: false,
      initial: 0,
      total: 0,
      percent: 0,
    },
  }),
  mounted() {
    this.completeForm();

    this.$vs.loading({
      color: "danger",
    });
    new Mailing()
      .getTypes()
      .then((response) => {
        response.data.forEach((el) => {
          if (!this.sale.blocked.includes(el.CODIGO)) {
            this.sale.item.push({
              value: el.CODIGO,
              text: `${el.CODIGO} - ${el.NOME}`,
            });
          }
        });
      })
      .catch((response) => {
        if (response && response.data) {
          this.notify.error = response.data.error;
          this.$vs.notify({
            title: "Um erro foi encontrado",
            text: this.notify.error,
            color: "danger",
          });
        }
      })
      .finally(() => {
        this.$vs.loading.close();
      });
    window.addEventListener("load", this.onLoad());
  },
  methods: {
    clearPhone(phone) {
      return phone.toString().replace(/[ ()-]/g, "");
    },
    goTo(route) {
      this.$router.push(route);
    },
    completeForm() {
      this.$vs.loading({
        color: "danger",
      });
      new Mailing()
        .getForm(this.sale.selected)
        .then((response) => {
          response.data.forEach((item) => {
            if (item.name == "CODATENDENTE") {
              this.constructForm__FilaDeAtendimento(item);
            }
            if (item.name == "CODLOCAL") {
              this.constructForm__Localidade(item);
            }
            if (item.name == "CODCAMPANHA") {
              this.constructForm__Campanha(item);
            }
          });
        })
        .catch((response) => {
          if (response && response.data) {
            this.notify.error = response.data.error;
            this.$vs.notify({
              title: "Um erro foi encontrado",
              text: this.notify.error,
              color: "danger",
            });
          }
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    constructForm__FilaDeAtendimento(item) {
      if (item.items.length > 0) {
        this.service.item = [];
        item.items.forEach((el) => {
          this.service.item.push({ value: el.value, text: el.title });
        });
      }
    },
    constructForm__Localidade(item) {
      if (item.items.length > 0) {
        this.locality.item = [];
        item.items.forEach((el) => {
          this.locality.item.push({ value: el.value, text: el.title });
        });
      }
    },
    constructForm__Campanha(item) {
      if (item.items.length > 0) {
        this.campaing.item = [];
        item.items.forEach((el) => {
          this.campaing.item.push({ value: el.value, text: el.title });
        });
      }
    },
    valideFileForm() {
      let valide = true;
      if (this.service.selected == null) {
        valide = false;
      }
      if (this.locality.selected == null) {
        valide = false;
      }
      if (this.campaing.selected == null) {
        valide = false;
      }
      this.valide.inputFile = valide;
    },
    onLoad() {
      let targetBox = this.$refs.fileBoxDrop;
      targetBox.addEventListener("change", (e) => {
        e.preventDefault();
        this.handleDrop(e.target.files[0]);
      });
      targetBox.addEventListener("dragover", (e) => {
        e.preventDefault();
      });
      targetBox.addEventListener("drop", (e) => {
        e.preventDefault();
        if (
          e.dataTransfer.files[0].type ==
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        ) {
          this.handleDrop(e.dataTransfer.files[0]);
        } else {
          this.innerHTML.boxInput =
            '<big class="bg-danger">ARQUIVO INVÁLIDO</big><br>ARRASTE OU CLIQUE PARA ENVIAR SEU ARQUIVO <br/><small>NO FORMATO XLSX</small>';
        }
      });
    },
    async handleDrop(f) {
      let file = new FileReader();
      try {
        file.readAsBinaryString(f);
        file.onprogress = (event) => {
          this.innerHTML.boxInput = `Fazendo a leitura do arquivo<br /><span>${f.name}</span><br />${event.loaded}/${event.total}`;
          this.$vs.loading({
            color: "danger",
          });
        };

        file.onload = async (event) => {
          let excel = XLSX.read(event.target.result, { type: "binary" }),
            sheetName = excel.SheetNames[0];

          var sheet = XLSX.utils.sheet_to_row_object_array(
            excel.Sheets[sheetName]
          );

          let table = [];
          for (let index = 0; index < sheet.length; index++) {
            let obj = {};
            obj.name = this.validateName(sheet[index].Nome);
            obj.phone = await this.validateTelephone(sheet[index].Telefone);
            obj.mail = this.validateEmail(sheet[index].Email);
            obj.codCourse = this.validateCodCourse(sheet[index].CodCurso);
            obj.course = this.validateCourse(sheet[index].Curso);
            obj.note = this.validateNote(sheet[index].Obs);
            table.push(obj);
          }
          //valida repetidos
          let repetidos = false;
          for (let x = 0; x < table.length; x++) {
            let count = 0;
            for (let i = 0; i < table.length && repetidos === false; i++) {
              if (
                this.clearPhone(table[x].phone.phone) ===
                this.clearPhone(table[i].phone.phone)
              )
                count++;
            }
            if (count > 1) repetidos = true;
          }

          if (repetidos) {
            this.valide.table = false;
            this.innerHTML.boxInput =
              '<big class="bg-danger">ARQUIVO INVÁLIDO. REMOVA OS NÚMEROS REPETIDOS DO ARQUIVO ANTES DE IMPORTAR</big>';
            this.$vs.loading.close();
          } else {
            this.contentFile = table.map((field) => ({
              name: field.name.name,
              phone: field.phone ? field.phone.phone : "",
              mail: field.mail ? field.mail.mail : "",
              codCourse: field.codCourse ? field.codCourse.codCourse : "",
              course: field.course ? field.course.course : "",
              note: field.note ? field.note.note : "",
              finish: false,
              progress: 0,
              status: {
                hasSend:
                  field.name.hasSuccess &&
                  field.phone.hasSuccess &&
                  field.mail.hasSuccess &&
                  field.codCourse.hasSuccess &&
                  field.course.hasSuccess &&
                  field.note.hasSuccess,
                send: false,
                excerpt: [
                  field.name.excerpt,
                  field.phone.excerpt,
                  field.mail.excerpt,
                  field.codCourse.excerpt,
                  field.course.excerpt,
                  field.note.excerpt,
                ]
                  .filter((val) => val != "")
                  .join(", "),
              },
            }));
            this.valide.table = true;
            this.$vs.loading.close();
          }
        };
      } catch (error) {
        console.log(error);
        this.$vs.loading.close();
      }
    },
    validateName(value) {
      if (!value) {
        return {
          name: "",
          excerpt: "Nome Completo Inválido",
          hasSuccess: false,
        };
      }
      if (value.search(/\d/i) > -1) {
        return {
          name: value,
          excerpt: "Nome Completo contém caracter numérico",
          hasSuccess: false,
        };
      }
      return { name: value, excerpt: "", hasSuccess: true };
    },
    async validateTelephone(value) {
      if (!value) {
        return {
          phone: "",
          excerpt: "Telefone/Celular Inválido",
          hasSuccess: false,
        };
      }
      if (!validatePhone(value)) {
        return {
          phone: value,
          excerpt: "Telefone/Celular fora dos padrões.",
          hasSuccess: false,
        };
      }
      let phone = value.toString().replace(/[ ()-]/g, "");
      return this.valideProspect(phone);
    },

    async valideProspect(phone) {
      let result = null;
      await new Mailing()
        .validateProspect({
          telephone: phone,
          externalLink: 0,
        })
        .then(() => {
          result = { phone: phone, excerpt: "", hasSuccess: true };
        })
        .catch(() => {
          result = {
            phone: phone,
            excerpt: "Telefone/Celular já está cadastrado",
            hasSuccess: false,
          };
        });
      return result;
    },


    validateEmail(value) {
      if (!value) {
        return { mail: "", excerpt: "", hasSuccess: true };
      }
      if (
        !/^[a-zA-Z0-9][a-zA-Z0-9._-]+@([a-zA-Z0-9._-]+\.)[a-zA-Z-0-9]{2,3}$/i.test(
          value
        )
      ) {
        return { mail: value, excerpt: "Email inválido", hasSuccess: false };
      }
      if (value.length > 60) {
        return {
          mail: value,
          excerpt: "Tamanho de email não comportado pelo RM",
          hasSuccess: false,
        };
      }
      return { mail: value, excerpt: "", hasSuccess: true };
    },
    validateCourse(value) {
      if (!value) {
        return { course: "", excerpt: "", hasSuccess: true };
      }
      return { course: value, excerpt: "", hasSuccess: true };
    },
    validateCodCourse(value) {
      if (!value) {
        return { codCourse: "", excerpt: "", hasSuccess: true };
      }
      return { codCourse: value, excerpt: "", hasSuccess: true };
    },
    validateNote(value) {
      if (!value) {
        return { note: "", excerpt: "", hasSuccess: true };
      }
      return { note: value, excerpt: "", hasSuccess: true };
    },
    async sendMailerGroup() {
      this.$vs.loading();
      this.reloadProgress();
      this.importProgress.start = true;
      const processar = this.contentFile.filter(
        (el) => el.status.hasSend === true
      );

      for (const el of processar) {
        let payload = {
          NOME: el.name,
          CODORIGEM: "",
          TELEFONE: el.phone,
          EMAIL: el.mail,
          ESTADO: "",
          CODMUNICIPIO: "",
          CODTIPOATENDIMENTO: "213",
          LINKEXTERNO: "0",
          SOLICITACAO: el.note,
          CODLOCAL: this.locality.selected,
          CODCAMPANHA: this.campaing.selected,
          CODATENDENTE: this.service.selected,
          PARAMETRO_147: "",
          PARAMETRO_148: {"CODIGO":el.codCourse, "NOME":el.course}, //{"NOME":"BACHAREL EM ADMINISTRAÇÃO","CODIGO":"109"}
          PARAMETRO_149: "",
        };
        el.progress = 10;
        await new Mailing()
          .registerMailing(payload)
          .then((send) => {
            el.status.send = true;
            el.progress = 100;
            el.status.excerpt =
              "Atendimento criado: " + send.data.CODATENDIMENTO;
          })
          .catch((send) => {
            console.log("REJECT", send);
            el.status.send = false;
            el.progress = 0;
            el.status.excerpt = "Erro de importação";
          })
          .finally(() => {
            el.finish = true;
            this.reloadProgress();
          });
      }
      this.$vs.loading.close();
    },
    reloadProgress() {
      let countEl = this.contentFile.filter(
        (el) => el.status.hasSend === true
      ).length;
      let elPartial = this.contentFile
        .filter((el) => el.status.hasSend === true)
        .map((el) => {
          if (el.finish === true) {
            return el;
          }
        })
        .filter((el) => typeof el !== "undefined");
      this.importProgress.total = countEl;
      this.importProgress.initial = elPartial.length;
      this.importProgress.percent = parseInt(
        (100 * elPartial.length) / countEl
      );
    },
  },
};
</script>

<style>
.legend_form {
  color: #404040;
  font-weight: 700;
  padding: 20px 0px;
}
#boxDrop {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40vh;
  background: #f3f3f3;
  border: 3px dashed #404040;
  font-weight: 700;
  color: #404040;
  text-align: center;
}
#boxDrop:hover,
#boxDrop:hover > * {
  background: #e4e4e4;
  cursor: pointer;
}
.w100 {
  width: 100%;
}
.bg-danger {
  background: red;
  color: white;
  padding: 10px 20px;
  display: block;
}
.centerx {
  text-align: center;
}
.small {
  font-size: 0.7rem;
}
.bt_import {
  background: #c50711;
  color: white;
  font-weight: bolder;
  font-size: 1.3rem;
  padding: 20px 40px;
  border-radius: 15px;
  display: block;
  text-align: center;
  cursor: pointer;
}
.bt_import:hover {
  background-color: #f44336;
}
</style>
